// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--9414a";
export var footerBottom = "footer-module--footer-bottom--d54d6";
export var footerContent = "footer-module--footer-content--e51c3";
export var footerLinks = "footer-module--footer-links--c8cbd";
export var footerRss = "footer-module--footer-rss--50510";
export var footerSocial = "footer-module--footer-social--6f32f";
export var goToHead = "footer-module--go-to-head--cb896";